// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__3ylP4","thumbnail":"thumbnail__psHZo","text":"text__qLLGS","main":"main__1QWMU","sub":"sub__2RfYe","border":"border__1gIMs","button-toolbar":"button-toolbar__30oDU"};